import _isNil from "lodash/isNil";
import { DomainName } from 'utils/deploymentInfo';
import { termsOfUseCognitoKey, institutionCognitoKey } from 'const';
var termsOfUseNotAccepted = function termsOfUseNotAccepted(user, domainName) {
  var notAccepted = (user === null || user === void 0 ? void 0 : user.attributes[termsOfUseCognitoKey]) !== 'true';
  var institution = user === null || user === void 0 ? void 0 : user.attributes[institutionCognitoKey];
  var institutionNotSet = _isNil(institution) || institution.length === 0;
  return (notAccepted || institutionNotSet) && (domainName === DomainName.BIOMAGE || domainName === DomainName.BIOMAGE_STAGING);
};
export default termsOfUseNotAccepted;